// Header
export const headerTexts = {
    title: 'Introducing our Transformative Operating Model',
    subtitle: 'Curious about TOM? Just ask TOMI',
};

// Improve prompt
export const improvePromptTexts = {
    header: 'Prompt improvement',
};

export const improvePromptButtons = {
    cancel: 'Cancel',
    reload: 'Reload',
    addAsInput: 'Add as input',
};

// Message input
export const messageInputTexts = {
    placeholder: 'What do you want to know?',
    tooltip:
        'Warning: Clicking will clear the chat and remove the message you are currently typing',
};

export const messageInputButtons = {
    promptImprovement: 'Prompt improvement',
    send: 'Send',
    stop: 'Stop',
    clearChatAndInput: 'Clear',
};

// Message stack
export const messageStackTexts = {
    userLabel: 'You',
    tomiLabel: 'TOMI',
    tomiWarning: 'TOMI tries its best, but can sometimes get things wrong. Better to double-check!',
    hideShowCitationsButton: 'References',
    downloadCitationButton: 'Download document',
};

// Additional features
export const additionalFeaturesTexts = {
    rolePlaceholder: 'Select your role',
    countryPlaceholder: 'Select your country',
    predefinedPromptsPlaceholder: 'Predefined prompts',
    exportToMSWorld: 'Export to MS Word',
};
